import { render, staticRenderFns } from "./ModalHistoryDetail.vue?vue&type=template&id=1ed1a77e&scoped=true"
import script from "./ModalHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ModalHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoryDetail.vue?vue&type=style&index=0&id=1ed1a77e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed1a77e",
  null
  
)

export default component.exports